module.exports = __webpack_public_path__ + "static/img/youxiang@2x.16d0245b.png";